import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import useBrand from "./useBrand";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';

export default function () {
  const { brandFields, handleSubmit, setData, setErrors } = useBrand();
  const navigate = useNavigate();
  const token = useSelector(state => state.token);

  const addBrand = data => {
    const formData = new FormData();

    Object.entries(data).forEach(([property, value]) => {
      formData.append(`${property}`, value || '');
    });

    axios.post('brands', formData)
      .then(function (res) {
        if (res.status == 200) {
          swal('Brand "' + res.data.brand.name + '" has been created successfully!', {
            icon: "success",
          });
          navigate("/brands");
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Add brand">
      <form className="form w-100 row" onSubmit={handleSubmit(addBrand)}>
        {brandFields}
        <SubmitButton
          title="Add"
          classes="w-auto d-inline-block float-right"
        />
      </form>
    </Card>
  );
}